import { render } from "./DashboardEmpty.vue?vue&type=template&id=666860b8&scoped=true"
import script from "./DashboardEmpty.vue?vue&type=script&lang=js"
export * from "./DashboardEmpty.vue?vue&type=script&lang=js"

import "./DashboardEmpty.vue?vue&type=style&index=0&id=666860b8&scoped=true&lang=scss"

import exportComponent from "/Users/macbook/Documents/personal/freelance-sabdulla/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-666860b8"]])

export default __exports__